export const numberFormatter = (value, toFixedNumber = null) => {
  if (toFixedNumber != null) {
    return Number((+value).toFixed(toFixedNumber)).toLocaleString('en-US');
  } else {
    return Number(+value).toLocaleString('en-US');
  }
};
